import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {store} from './store/store';
import {Provider} from 'react-redux';
import * as serviceWorker from './serviceWorker';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/cyrillic.css';
import '@fontsource/roboto/cyrillic-ext.css';
import 'normalize.css';
import CssBaseline from '@mui/material/CssBaseline';
import {SnackbarProvider} from 'notistack';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {ruRU} from '@mui/x-date-pickers/locales';
import 'dayjs/locale/ru';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider
        adapterLocale="ru"
        dateAdapter={AdapterDayjs}
        localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <CssBaseline/>
        <SnackbarProvider maxSnack={3}>
          <App/>
        </SnackbarProvider>
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
